export function groupPlayerNotifications(rows) {
  const result = [];
  const groups = new Map();
  for (const row of rows) {
    if (row.group_key && row.action_status === "information") {
      if (!groups.has(row.group_key)) {
        const group = { id: row.group_key, rows: [] };
        groups.set(row.group_key, group);
        result.push(group);
      }
      groups.get(row.group_key).rows.push(row);
    } else result.push({ id: row.id, rows: [row] });
  }
  return result;
}

export function playerNotificationLink(value) {
  return /^\/(today|services|requests|daily-check|notifications)([/?]|$)/.test(value || "") ? value : "/notifications";
}

export function playerPlanGroupDate(groupKey, lang) {
  if (!/^plan:\d{4}-\d{2}-\d{2}$/.test(groupKey || "")) return "";
  return new Intl.DateTimeFormat(lang === "de" ? "de-DE" : "en-GB", {
    day: "numeric", month: "short", year: "numeric", timeZone: "UTC",
  }).format(new Date(`${groupKey.slice(5)}T12:00:00Z`));
}
